module Omni.ResortMap {
    ngModule.controller('MainController',
        ['DataService', 'ResortProvider', '$scope', '$state', '$stateParams',
            function (DataService, ResortProvider, $scope, $state, $stateParams) {
                $scope.resort = null;

                DataService.get({}, function (data) {
                    $scope.resort = data;
                    $scope.isResort = data.is_resort;
                    ResortProvider.setResort(data);
                    if ($scope.isResort) {
                        $state.go('resort');
                    } else {
                        $state.go('floor', { id: 0 });
                    }
                });
            }
        ]);
}
